const getInitialState = () => ({
	isVisible: false,
	message: ''
});

export default getInitialState;
